/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type WordListConfigContainer_settings = {
    readonly wordList: {
        readonly suspect: ReadonlyArray<string>;
        readonly banned: ReadonlyArray<string>;
    };
    readonly premoderateSuspectWords: boolean;
    readonly " $refType": "WordListConfigContainer_settings";
};
export type WordListConfigContainer_settings$data = WordListConfigContainer_settings;
export type WordListConfigContainer_settings$key = {
    readonly " $data"?: WordListConfigContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"WordListConfigContainer_settings">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WordListConfigContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "WordList",
            "kind": "LinkedField",
            "name": "wordList",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "suspect",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "banned",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "premoderateSuspectWords",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any;
(node as any).hash = '55089bbc57cc1a3b60887e49334bd461';
export default node;
